<div class="row">
  <div class="col-sm-12 col-xl-10 col-md-12 my-2">
    <div class="perPageDatatable">
      <ng-container *ngIf="(paginationPosition === 'top' || paginationPosition === 'both') && isPaginationEnable">
        <ng-container *ngTemplateOutlet="pagination"></ng-container>
      </ng-container>
      <ng-container *ngIf="resetFilters"
        ><button (click)="onResetFilters()" type="button" class="btn btn-warning">
          <i class="uil uil-redo"></i>
          <span class="hidebuttonName">{{ 'reset.value' | translate }}</span>
        </button>
      </ng-container>
      <ng-container *ngIf="isPrintEnable">
        <button (click)="onBtnPrint()" type="button" class="btn btn-soft-primary">
          <i class="uil uil-print"></i>
          <span class="hidebuttonName"> {{ 'print.value' | translate }}</span>
        </button>
      </ng-container>
      <ng-container *ngIf="isExportable">
        <button (click)="onBtnExport()" type="button" class="btn btn-soft-purple">
          <i class="uil uil-export"></i>
          <span class="hidebuttonName"> {{ 'export.value' | translate }}</span>
        </button>
      </ng-container>
      <ng-container *ngIf="isDeletable">
        <button (click)="getSelectedRowsData()" type="button" class="btn btn-danger">
          <i class="uil uil-trash"></i>
          <span class="hidebuttonName"> {{ 'delete.value' | translate }}</span>
        </button>
      </ng-container>
      <ng-content class="xlx" select="[topButtons]"></ng-content>
      <div class="input-group my-auto dateRangeSelector" *ngIf="isDateRangeSelectionOn">
        <div class="input-group-text bg-primary text-white border-r-none">
          <i class="uil uil-calendar-alt"></i>
        </div>
        <input
          class="form-control flatpickr-input mw-25"
          type="text"
          (input)="onDateRangeSelect()"
          [(ngModel)]="dateRange"
          mwlFlatpickr
          mode="range"
          [convertModelValue]="true"
        />
      </div>
    </div>
  </div>
  <ng-container *ngIf="isSearchable">
    <div class="col-sm-12 col-xl-2 col-md-12 d-flex my-2">
      <div class="input-group my-auto">
        <div class="input-group-text theme-bg text-black border-r-none">
          <i class="uil uil-search"></i>
        </div>
        <input
          type="text"
          class="form-control"
          placeholder="{{ 'search.value' | translate }}"
          [(ngModel)]="queryParams"
          (ngModelChange)="queryParamsSubject.next(queryParams)"
        />
      </div>
    </div>
  </ng-container>
  <app-common-loading [count]="perPage > 0 ? perPage : 10" [appearance]="'line'" [isLoading]="isLoading">
    <div class="col-12 mt-2" *ngIf="showGrid" #grid>
      <ag-grid-angular
        [gridOptions]="gridOptions"
        id="commonGrid"
        [domLayout]="useGridScroll ? 'normal' : 'autoHeight'"
        class="ag-theme-material"
        [class.grid-native-scroll]="useGridScroll"
        (modelUpdated)="onModelUpdated()"
        [rowData]="rowData"
        [pagination]="isPaginationEnable"
        [suppressPaginationPanel]="true"
        [paginationPageSize]="perPage"
        [defaultColDef]="defaultColDef"
        [animateRows]="true"
        [rowDragManaged]="true"
        (rowDragEnd)="onRowDragEnd($event)"
        [suppressRowClickSelection]="true"
        [rowGroupPanelShow]="rowGroupPanelShow"
        [columnDefs]="columnDefs"
        (sortChanged)="onSortChange($event)"
        (dragStopped)="onColumnOrderChange()"
        (filterChanged)="onfilterChange($event)"
        (gridReady)="onGridReady($event)"
        [suppressExcelExport]="true"
        [rowSelection]="rowSelection"
        [enableRtl]="enableRtl"
        [loadingOverlayComponent]="loadingOverlayComponent"
        [loadingOverlayComponentParams]="{ gridCount: perPage > 3 ? perPage : 3 }"
        [suppressDragLeaveHidesColumns]="true"
        [overlayNoRowsTemplate]="'No Record Found'"
        [enableCellTextSelection]="true"
      >
      </ag-grid-angular>
      <!--  //customLoading -->
      <!-- [loadingOverlayComponent]="loadingOverlayComponent" -->
    </div>
  </app-common-loading>
  <div class="col-12" *ngIf="(paginationPosition === 'bottom' || paginationPosition === 'both') && isPaginationEnable">
    <ng-container *ngTemplateOutlet="pagination"></ng-container>
  </div>
</div>
<ng-template #pagination>
  <div class="card">
    <div class="card-body">
      <div class="my-auto pagination-rounded perPageDatatable">
        <ngb-pagination
          [collectionSize]="collectionSize"
          [(page)]="currentPage"
          [maxSize]="6"
          [pageSize]="perPage"
          [rotate]="true"
          [ellipses]="true"
          [boundaryLinks]="true"
          (pageChange)="onPageClick($event)"
        ></ngb-pagination>
        <h6 class="my-auto">{{ 'perPage.value' | translate }}</h6>
        <ng-select
          style="min-width: 100px"
          [items]="pageSizeOptions"
          [(ngModel)]="perPage"
          (change)="onPageSizeChanged()"
          [searchable]="false"
          [clearable]="false"
          [appendTo]="'body'"
          bindLabel="pageSize"
          bindValue="value"
        >
        </ng-select>
        <div class="ms-auto">
          <h6 class="my-auto text-muted">
            <span class="mx-1">
              {{ currentPage === 1 ? 1 : (currentPage - 1) * perPage + 1 }}
            </span>
            {{ 'to.value' | translate }}
            <span class="mx-1">
              {{
                currentPage === 1
                  ? rowData?.length < perPage
                    ? rowData?.length
                    : perPage
                  : (currentPage - 1) * perPage + rowData?.length
              }}
            </span>
            {{ 'of.value' | translate }}
            {{ collectionSize }}
          </h6>
        </div>
      </div>
    </div>
  </div>
</ng-template>
